export const PARTIAL_MESSAGE = 'PARTIAL_MESSAGE';